export default {
  // 页面标题
  title: '业务负责人设置',

  // 搜索筛选区域
  search: {
    // 搜索条件标签
    employeeName: '员工姓名',
    businessType: '业务属性',
    position: '岗位',
    freightType: '运价类型',
    loadingPort: '起运港',
    destinationPort: '目的港',
    dischargePort: '卸货港',
    route: '航线',
    carrier: '承运人',
    client: '客户',

    // 占位符
    placeholder: {
      selectEmployee: '请选择员工姓名',
      selectBusinessType: '请选择业务属性',
      selectPosition: '请选择岗位',
      selectFreightType: '请选择运价类型',
      selectLoadingPort: '请选择起运港',
      selectDestinationPort: '请选择目的港',
      selectDischargePort: '请选择卸货港',
      selectRoute: '请选择航线',
      selectCarrier: '请选择承运人',
      selectClient: '请选择客户'
    },

    // 按钮
    search: '查询',
    reset: '重置',
    expand: '展开',
    collapse: '收起'
  },

  // 操作按钮区域
  actions: {
    addManager: '新增负责人',
    batchDelete: '批量删除',
    totalRecords: '共 {count} 条记录'
  },

  // 表格列标题
  table: {
    columns: {
      serialNumber: '序号',
      employee: '员工',
      businessType: '业务属性',
      position: '岗位',
      freightType: '运价类型',
      loadingPort: '起运港',
      destinationPort: '目的港',
      dischargePort: '卸货港',
      route: '航线',
      carrier: '承运人',
      client: '客户',
      createdBy: '创建人',
      createdTime: '创建时间',
      modifiedBy: '修改人',
      modifiedTime: '修改时间',
      actions: '操作'
    },

    // 操作按钮
    actions: {
      edit: '编辑',
      delete: '删除'
    }
  },

  // 模态框
  modal: {
    title: {
      add: '新增业务负责人',
      edit: '编辑业务负责人'
    },

    // 按钮文本
    okText: '确定',
    cancelText: '取消',

    // 表单章节
    sections: {
      basicInformation: '基本信息',
      businessConfiguration: '业务配置',
      portAndRouteConfiguration: '港口和航线配置',
      partnerConfiguration: '合作伙伴配置'
    },

    // 表单字段
    form: {
      employee: '员工',
      businessType: '业务属性',
      position: '岗位',
      freightType: '运价类型',
      loadingPort: '起运港',
      destinationPort: '目的港',
      dischargePort: '卸货港',
      route: '航线',
      carrier: '承运人',
      client: '客户',

      // 占位符
      placeholder: {
        selectEmployee: '请选择员工',
        selectBusinessType: '请选择业务属性',
        selectPosition: '请选择岗位',
        selectFreightType: '请选择运价类型',
        selectLoadingPort: '请选择起运港',
        selectDestinationPort: '请选择目的港',
        selectDischargePort: '请选择卸货港',
        selectRoute: '请选择航线',
        selectCarrier: '请选择承运人',
        selectClient: '请选择客户'
      },

      // 验证消息
      validation: {
        selectEmployee: '请选择员工',
        selectBusinessType: '请选择业务属性',
        selectPosition: '请选择岗位'
      }
    }
  },

  // 确认对话框
  confirm: {
    delete: {
      title: '确认删除',
      content: '删除后无法恢复，确认删除？（已存在的业务不受影响）',
      okText: '确定',
      cancelText: '取消'
    }
  },

  // 消息提示
  message: {
    success: {
      create: '创建成功',
      update: '更新成功',
      delete: '删除成功',
      batchDelete: '成功删除 {count} 个业务负责人'
    },
    error: {
      loadFailed: '数据加载失败',
      createFailed: '创建失败',
      updateFailed: '更新失败',
      deleteFailed: '删除失败',
      batchDeleteFailed: '批量删除失败',
      operationFailed: '操作失败'
    },
    warning: {
      managerIdNotExists: '业务负责人ID不存在',
      noSelection: '请选择要删除的业务负责人'
    }
  }
}
